import { createVNode as _createVNode } from "vue";
import { defineComponent, useCssModule, computed } from "vue";
export default defineComponent({
  props: {
    title: String,
    data: [Array],
    isMl0: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    itemWidth: {
      type: String,
      default: "350px"
    },
    itemHeight: {
      type: String,
      default: "18px"
    }
  },
  setup(props, ctx) {
    function getContent(d) {
      if (typeof d.content == 'function') {
        return d.content();
      } else if (typeof d.content == 'string') {
        return String(d.content) || '';
      } else {
        return d.content;
      }
    }
    const css = useCssModule("css");
    const myData = computed(() => {
      if (props.data) {
        props.data.forEach(item => {
          if (typeof item == "object" && item && item.show === undefined) {
            item.show = true;
          }
        });
        return props.data.filter(d => !!d && d.show);
      }
      return [];
    });
    return () => _createVNode("div", {
      "class": [css.detail]
    }, [props.title && _createVNode("h3", {
      "class": css.title
    }, [props.title]), _createVNode("div", {
      "class": [css.cont, {
        ml_0: props.isMl0
      }, {
        m_0: props.noMargin
      }]
    }, [myData.value.map(d => _createVNode("div", {
      "class": [css.cont_item, {
        w100: props.block
      }, {
        [css.base_line]: props.block
      }],
      "style": {
        "width": props.itemWidth
        // height: props.itemHeight,
        // lineheight: props.itemHeight,
      }
    }, [_createVNode("div", {
      "class": css["no_wrap"]
    }, [`${d.title}：`]), _createVNode("div", {
      "class": [{
        w70: props.block
      }, 'ellipsis'],
      "title": getContent(d)
    }, [getContent(d)])]))])]);
  }
});